import {createContext} from 'react'

import type {NotificationsContext as ContextType} from './types'

export const NotificationsContext = createContext<ContextType>(null)
export const NotificationsProvider = NotificationsContext.Provider
